import { useState } from "react";
import { getValidationErrorMessage, validateRegistration } from "../../services/registrationApi";
import styles from "./AccessGateway.module.scss";

function AccessGateway({ onLogin }) {
  const [credentials, setCredentials] = useState({ ibm: "", email: "" });
  const [errors, setErrors] = useState({});
  const [submitError, setSubmitError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const updateCredential = (event) => {
    const { name, value } = event.target;
    setCredentials((current) => ({ ...current, [name]: value }));
    setErrors((current) => ({ ...current, [name]: "" }));
    setSubmitError("");
  };

  const handleLogin = async (event) => {
    event.preventDefault();
    const nextErrors = {
      ibm: credentials.ibm.trim() ? "" : "Informe seu IBM.",
      email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(credentials.email.trim()) ? "" : "Informe um e-mail válido.",
    };
    setErrors(nextErrors);
    if (nextErrors.ibm || nextErrors.email) return;

    setSubmitError("");
    setIsSubmitting(true);

    try {
      const result = await validateRegistration(credentials);

      if (!result?.ok || !result?.exists) {
        setSubmitError(result?.message || "IBM e e-mail não encontrados. Confira os dados informados.");
        return;
      }

      onLogin(result.data || credentials, credentials);
    } catch (error) {
      setSubmitError(getValidationErrorMessage(error));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className={styles.section} aria-labelledby="login-title">
      <div className={styles.layout}>
        <header className={styles.heading}>
          <h1 id="login-title">Bem-vindo(a)!</h1>
          <p>
            Estamos preparando uma experiência exclusiva
            <br />
            para vocês no GP de São Paulo 2026.
            <br />
            Confirme sua presença e atualize seus dados.
          </p>
        </header>

        <form className={styles.card} onSubmit={handleLogin} noValidate>
          <div className={styles.field}>
            <label htmlFor="login-ibm">IBM</label>
            <input id="login-ibm" name="ibm" value={credentials.ibm} onChange={updateCredential} autoComplete="username" inputMode="numeric" placeholder="Ex.: 123456" aria-invalid={Boolean(errors.ibm)} />
            <span>{errors.ibm || "Use o número do seu IBM."}</span>
          </div>
          <div className={styles.field}>
            <label htmlFor="login-email">E-mail</label>
            <input id="login-email" name="email" type="email" value={credentials.email} onChange={updateCredential} autoComplete="email" inputMode="email" placeholder="nome@empresa.com" aria-invalid={Boolean(errors.email)} />
            <span>{errors.email || "Digite seu e-mail cadastrado."}</span>
          </div>

          {submitError ? <p className={styles.loginError} role="alert">{submitError}</p> : null}

          <button className={styles.submitButton} type="submit" disabled={isSubmitting}>
            {isSubmitting ? "Validando..." : "Continuar"}
          </button>
        </form>

      </div>
    </section>
  );
}

export default AccessGateway;
